class ProductHistory extends HTMLElement {
  constructor() {
    super();
    this.earBtns = this.querySelectorAll('.era__btn');
    this.earBtns.forEach(btn => {
      btn.addEventListener('click', this.onBtnClick.bind(this));
    })
  }

  onBtnClick(e) {
    const thisEra = e.target.closest('.product-history__era');
    const ctaContent = thisEra.querySelectorAll('.era__cta-content');
    const balloon = thisEra.querySelector('.era__message');

    // 1. Show/Hide CTA content
    ctaContent.forEach(el => el.classList.toggle('hidden'));

    // 2. Show/Hide balloon
    balloon.classList.toggle('active');
  }
}

customElements.define('product-history', ProductHistory);